import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import HotelImportStatus from 'components/HotelImportStatus';

import { HotelImportsTableRow_import$key } from '__generated__/HotelImportsTableRow_import.graphql';

type Props = {
  import: HotelImportsTableRow_import$key;
};

const HotelImportsTableRow: FC<Props> = props => {
  const hotelImport = useFragment(
    graphql`
      fragment HotelImportsTableRow_import on HotelImport {
        id
        totalRows
        currentRow
        hotelsImported
        createdAt
        updatedAt

        ...HotelImportStatus_hotelImport
      }
    `,
    props.import
  );

  const { totalRows, currentRow, hotelsImported, createdAt, updatedAt } =
    hotelImport;

  return (
    <TableRow>
      <TableCell>{createdAt}</TableCell>

      <TableCell align="center">
        <HotelImportStatus hotelImport={hotelImport} />
      </TableCell>

      <TableCell align="center">{totalRows}</TableCell>
      <TableCell align="center">{currentRow}</TableCell>
      <TableCell align="center">{hotelsImported}</TableCell>
      <TableCell align="center">{updatedAt}</TableCell>
    </TableRow>
  );
};

export default HotelImportsTableRow;
